<script lang="ts">
	import { Icon } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';

	/** Icon class for the header badge */
	export let icon: string = 'fas fa-badge-percent';
	/** Header label text */
	export let label: string = $format('label_special_offers', { default: 'Special offers' });
</script>

<div class="promo-dropdown-header d-flex align-items-center gap-xs">
	<Icon size="xs" {icon} class="text-color-muted" />
	<span class="promo-dropdown-header__label">{label}</span>
</div>

<style>
	.promo-dropdown-header__label {
		font-size: 10px;
		font-weight: 500;
		letter-spacing: 0.6px;
		line-height: normal;
		text-transform: uppercase;
		color: var(--color-muted, #a1a2a2);
	}
</style>
